import React, { useState } from 'react';
import { connect } from 'react-redux';

import Agents from './transferTicket/Agents'
import Counters from './transferTicket/Counters';
import Services from './transferTicket/Services';

function TransferTicket(props){
    const [transfer, selectTransfer] = useState('default')
    switch (transfer){
        case 'agents':
        return <Agents returnFunction={selectTransfer} />
        case 'services':
        return <Services returnFunction={selectTransfer} />
        case 'supportDesks':
        return <Counters returnFunction={selectTransfer} />

        default:
        return (
            <div className="home-center-content1 home-center-content3">
                <h5>Transfer Ticket</h5>
                <div className='radioLinks'>
                    <div onClick={ () => selectTransfer('services') }>Transfer to Service</div>
                    <div onClick={ () => selectTransfer('agents') }>Transfer to Agent</div>
                    <div onClick={ () => selectTransfer('supportDesks') }>Transfer to Support Desk</div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        tickets: state.tickets.tickets,
    }
}

export default connect(mapStateToProps, {})(TransferTicket);